module.exports = __webpack_public_path__ + "static/media/ic_how_to_claim_fisdom.176c2c12.svg";